import Vue from 'vue';
// Initial State
const state = () => ({
    budget: {
        quotationId: null,
        cameFromBudget: false,
        cameFromHistory: false,
        plate: null,
        internalId: null,
        dataSourceId: null
    },

    planningDates: {
        startDate: null,
        endDate: null,
        stepDays: 1,
        oldStartDate: null,
        oldEndDate: null,
    },

    planningEvent: {},
    
    newPlanningEvent: {},

    garagesAndUsers: {}
});

// Mutations
const mutations = {
    setPlanningBudgetState(state, payload) {
        state.budget.quotationId = payload.quotationId;
        state.budget.cameFromBudget = payload.cameFromBudget;
        state.budget.cameFromHistory = payload.cameFromHistory;
        state.budget.plate = payload.plate;
        state.budget.internalId = payload.internalId;
        state.budget.dataSourceId = payload.dataSourceId
    },

    setPlanningQuotationId(state, payload) {
        state.budget.quotationId = payload;
    },

    setPlanningCameFromBudget(state, payload) {
        state.budget.cameFromBudget = payload;
    },

    async setPlanningDates(state, payload) {

        state.planningDates.oldStartDate = state.planningDates.startDate ? state.planningDates.startDate : payload.start;
        state.planningDates.oldEndDate = state.planningDates.endDate ? state.planningDates.endDate : payload.end;

        await Vue.nextTick(() => {
            state.planningDates.startDate = payload.start;
            state.planningDates.endDate = payload.end;
            state.planningDates.stepDays = payload.stepDays;
        });
    },

    setGaragesUsersState(state, payload) {
        state.garagesAndUsers = payload;
    },

    setPlanningEvent(state, payload) {
        state.planningEvent = payload;
        // localStorage.setItem('@datadrive:planning-event', JSON.stringify(payload));
        // this.dispatch('planning/updatePlanningLocalStorage');
    },
    
    setNewPlanningEvent(state, payload) {
        state.newPlanningEvent = payload;
    },

    setClearPlanning(state, payload) {
        state.budget.quotationId = null;
        state.budget.cameFromBudget = false;
        state.budget.cameFromHistory = false;
        state.budget.plate = null;
        state.budget.internalId = null;
    }
  };

// Actions
const actions = {
    updatePlanningLocalStorage(state) {
        localStorage.setItem('@datadrive:planning-event', JSON.stringify(state.planningEvent));
    },
};

// Getters
const getters = {

    getPlanningState(state) {
        for (var [key, value] of Object.entries(state)) {
            return state[key] = value;
        }
    },

    getPlanningBudgetState(state) {
        return state.budget;
    },

    getPlanningDates(state) {
        return state.planningDates;
    },

    getGaragesUsers(state) {
        return state.garagesAndUsers;
    },

    getPlanningEvent(state) {
        return state.planningEvent;
    },
    
    getNewPlanningEvent(state) {
        return state.newPlanningEvent;
    }
  };

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
